export type JobSummary = {
  last_report: TaskResultReportSuccess | TaskResultReportError;
  reports: (TaskResultReportError | TaskResultReportSuccess)[];
  total_reports: number;
};

export type Job = {
  id: number;
  action_name: string;
  arguments: {
    [key: string]: any;
  };
  user: number;
  user_email?: string | null;
  customer: number;
  created: string;
  status_from_tasks_result: OurJobStatus; // COLLECTED STATUS FROM TASKS RESULT

  summary?: {
    [key: string]: JobSummary;
  };
  running_tasks?: ParentTask[];
  last_run_task?: ParentTask;
  failed_product_list_url?: string;
  success_product_list_url?: string;
  all_product_list_url?: string;
};

export type TaskResultReportBase = {
  resource_id: string | number;
  resource_type: string;
  resource_name: string | null;
  resource_url: string | null;
};

export type TaskResultReportSuccess = TaskResultReportBase & {
  can_replay: boolean | null;
  related_resources: TaskResultReportBase[] | null;
};

export type TaskResultReportError = TaskResultReportBase & {
  reason: string | null;
  can_replay: boolean | null;
  related_resources: TaskResultReportBase[] | null;
};

export type TaskResultReport = {
  error: TaskResultReportError[];
  success: TaskResultReportSuccess[];
  total: number;
};

export type TaskProgress = {
  success: number;
  error: number;
  total: number;
};

export type Task = {
  task_id: string;
  status: CeleryTaskStatus; // CELERY REPORTED STATUS
  status_from_result: CeleryTaskStatus; // STATUS CREATED FROM TASKS RESULT
  reports: TaskResultReport;
  created: string;
  updated: string;
  done: string;
  progress: TaskProgress;
  result: {
    [key: string]: any;
  };
};

export type ParentTask = Task & {
  failed_product_list_url: string | null;
  step_progress?: Record<string, { completed: number; total: number }>;
};

// Task state is unknown (assumed pending since you know the id).
const PENDING = "PENDING";
// Task was received by a worker (only used in events).
const RECEIVED = "RECEIVED";
// Task was started by a worker (:setting:`task_track_started`).
const STARTED = "STARTED";
// Task succeeded
const SUCCESS = "SUCCESS";
// Task failed
const FAILURE = "FAILURE";
// Task was revoked.
const REVOKED = "REVOKED";
// Task was rejected (only used in events).
const REJECTED = "REJECTED";
// Task is waiting for retry.
const RETRY = "RETRY";

export const READY_STATES = [SUCCESS, FAILURE, REVOKED];
export const UNREADY_STATES = [PENDING, RECEIVED, STARTED, REJECTED, RETRY];
export const EXCEPTION_STATES = [RETRY, FAILURE, REVOKED];
export const PROPAGATE_STATES = [FAILURE, REVOKED];

export type CeleryTaskStatus =
  | typeof PENDING
  | typeof RECEIVED
  | typeof STARTED
  | typeof SUCCESS
  | typeof FAILURE
  | typeof RETRY
  | typeof REVOKED
  | typeof REJECTED;

export type OurJobStatus = CeleryTaskStatus | "NO_PARENT_TASK" | "UNDETERMINED";

export type OurJobStatusDropdownChoices = Extract<
  OurJobStatus,
  "PENDING" | "SUCCESS" | "FAILURE" | "NO_PARENT_TASK"
>;
